import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Formik, Field, Form } from 'formik';
import {
  IonLoading,
  IonButton,
  IonNote,
  IonList,
  IonAlert,
} from '@ionic/react';
import { useHistory } from 'react-router-dom';
import pick from 'lodash/pick';
import { InputField } from 'components/form';
import AppActions from 'redux/AppRedux';
import AuthActions, { AuthSelectors } from 'redux/AuthRedux';
import { humanizePhone } from 'utils/phone';
import moment from 'moment';
import api_v2 from 'services/api_v2';
import schema from './schema';

function UpdateUserForm() {
  const dispatch = useDispatch();
  const token = useSelector(AuthSelectors.selectToken);
  const user = useSelector(AuthSelectors.selectUser);
  const history = useHistory();
  const [showAlert, setShowAlert] = useState(false);

  const handleDelete = async () => {
    try {
      const api = api_v2(token);
      await api.deleteAccount();
      dispatch(AuthActions.logout());
    } catch (e) {
      dispatch(
        AppActions.setToast(
          e.message || 'There was problem deleting account',
          'danger'
        )
      );
    }
  };

  const handleSubmit = async (payload, actions) => {
    try {
      const api = api_v2(token);

      const updateParams = {
        firstName: payload.firstName,
        lastName: payload.lastName,
        email: payload.email,
        birthday: !payload.birthday ? undefined : new Date(payload.birthday),
      };

      console.log('Me Update Params: ', updateParams);

      const updatedUser = await api.updateUser(updateParams);

      dispatch(AuthActions.setUser(updatedUser));

      dispatch(AppActions.setToast('Saved successfully', 'success'));
    } catch (e) {
      console.log(e);
      dispatch(
        AppActions.setToast(
          e.message || 'There was problem updating user',
          'danger'
        )
      );
    }
    
    actions.setSubmitting(false);
  };

  const INITIAL_STATE = {
    ...pick(user, ['firstName', 'lastName', 'email', 'birthday']),
    phone: humanizePhone(user.phone.replace('+1', '')),
    birthday:
      user.birthday && user.birthday !== ''
        ? moment.utc(user.birthday).format('YYYY-MM-DD')
        : '',
  };

  return (
    <Formik
      initialValues={INITIAL_STATE}
      onSubmit={handleSubmit}
      validationSchema={schema}
    >
      {({ isSubmitting }) => {
        return (
          <Form>
            <IonLoading isOpen={isSubmitting} message="Loading..." />
            <IonList>
              <Field
                component={InputField}
                name="firstName"
                label="First Name *"
                autoCapitalize="on"
              />
              <Field
                component={InputField}
                name="lastName"
                label="Last Name *"
                autoCapitalize="on"
              />
              <Field
                disabled
                component={InputField}
                name="phone"
                type="tel"
                label="Phone *"
                placeholder="XXX-XXX-XXXX"
                mask="999-999-9999"
                note={
                  user.phoneVerified ? (
                    <IonNote color="tertiary" slot="end">
                      <small>Verified</small>
                    </IonNote>
                  ) : (
                    <IonNote color="danger" slot="end">
                      <small>Not Verified</small>
                    </IonNote>
                  )
                }
              />
              <Field
                component={InputField}
                name="email"
                type="email"
                label="Email *"
                note={
                  user.emailVerified ? (
                    <IonNote color="tertiary" slot="end">
                      <small>Verified</small>
                    </IonNote>
                  ) : (
                    <IonNote color="danger" slot="end">
                      <small>Not Verified</small>
                    </IonNote>
                  )
                }
              />
              <Field
                component={InputField}
                type="date"
                name="birthday"
                label="Birthday"
                placeholder="MM/DD/YYYY"
                displayFormat="MM/DD/YYYY"
              />
              <div className="mb-2x mt-5x">
                <IonButton
                  color="secondary"
                  expand="block"
                  fill="solid"
                  type="submit"
                  disabled={isSubmitting}
                >
                  Save
                </IonButton>
              </div>
              <div className="mb-3x">
                <IonButton
                  color="secondary"
                  expand="block"
                  fill="solid"
                  type="button"
                  onClick={() => history.push('/change-password')}
                >
                  Change Password
                </IonButton>
              </div>
              <IonButton
                color="danger"
                expand="block"
                fill="solid"
                type="button"
                onClick={() => setShowAlert(true)}
              >
                Delete Account
              </IonButton>
            </IonList>
            <IonAlert
              isOpen={showAlert}
              onDidDismiss={() => setShowAlert(false)}
              header="Are you sure you want to delete your account?"
              message="If you delete your account, you'll lose your Vemos Pay transaction history and any rewards or promotions."
              buttons={[
                {
                  text: 'Cancel',
                  role: 'cancel',
                  cssClass: 'secondary',
                  handler: () => setShowAlert(false),
                },
                {
                  text: 'Yes',
                  handler: handleDelete,
                },
              ]}
            />
          </Form>
        );
      }}
    </Formik>
  );
}

export default UpdateUserForm;
